import { TOOL_NAMES } from 'js/src/agent/toolNames';

/** How to tidy a human recording, shared by the recorded-voiceover and talking-head skills. */
export function recordingCleanupGuidance(): string {
    return `## Cleaning up the recording
The words can't change, but the recording can be tightened: \`${TOOL_NAMES.cleanUpRecording}\` cuts its
filler words (um, uh, hmm…) and its pauses of a second or more. Only remove what the user asks
for (the ums and uhs, the filler words, the hesitations; the pauses, the silences, the dead air),
or says yes to when you offer: asking for one isn't asking for the other. Fillers and pauses are
part of how the speaker sounds, and cutting them shortens the video, so don't remove them on your
own while building, polishing or shortening a video; when a recording has a lot of them, you can
mention that you could take them out. A scene group's \`fillerWords\` count says how many fillers
are left; when it's absent there are none. Pauses are already in the transcript as
\`<pause seconds="N"/>\` tags; the ones of a second or more are what gets cut, and shorter ones are
the natural rhythm of speech and stay. Only the hesitation sounds count as fillers: "like", "so"
and "you know" are left in, so don't promise to remove them.`;
}
